import { useTranslation } from 'react-i18next';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import { useLanguage } from '@/i18n/LanguageContext';

// Consulting has no English landing, so the link is shown to RU users only.
const CONSULT_URL = 'https://create-products.com/consult?utm_source=app&utm_medium=cta&utm_campaign=crosslink&utm_content=limit_banner';

interface SubscriptionLimitBannerProps {
  title?: string;
  description?: string;
  buttonText?: string;
  navigateTo?: string;
}

export function SubscriptionLimitBanner({
  title,
  description,
  buttonText,
  navigateTo = '/subscription',
}: SubscriptionLimitBannerProps) {
  const { t } = useTranslation('common');
  const navigate = useLocalizedNavigate();
  const { lang } = useLanguage();

  const finalTitle = title ?? t('subscriptionLimit.title');
  const finalDescription = description ?? t('subscriptionLimit.description');
  const finalButtonText = buttonText ?? t('subscriptionLimit.button');

  return (
    <div className="mt-[16px] border border-[#ff9196] rounded-[16px] p-[24px]">
      <div className="flex flex-col gap-[16px]">
        <div className="flex items-start gap-[8px]">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="flex-shrink-0 mt-[2px]">
            <path d="M10 7V11" stroke="#0D0D0D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 16.6667C13.6819 16.6667 16.6667 13.6819 16.6667 10C16.6667 6.3181 13.6819 3.33333 10 3.33333C6.3181 3.33333 3.33333 6.3181 3.33333 10C3.33333 13.6819 6.3181 16.6667 10 16.6667Z" stroke="#0D0D0D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.99609 13.3333H10.0036" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div>
            <p className="font-manrope font-semibold text-[16px] md:text-[20px] leading-[24px] md:leading-[28px] text-[#0d0d0d] mb-[8px]">
              {finalTitle}
            </p>
            <p className="font-segoe text-[14px] leading-[20px] text-[#565858]">
              {finalDescription}
            </p>
          </div>
        </div>
        <button
          onClick={() => navigate(navigateTo)}
          className="bg-[#2197f1] hover:bg-[#1a7bc7] rounded-[16px] px-[24px] py-[12px] transition-colors"
        >
          <p className="font-segoe font-semibold text-[16px] leading-[24px] text-white text-center">
            {finalButtonText}
          </p>
        </button>
        {lang !== 'en' && (
          <a
            href={CONSULT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-segoe text-[14px] leading-[20px] text-[#2197f1] text-center hover:underline"
          >
            {t('subscriptionLimit.consultLink')}
          </a>
        )}
      </div>
    </div>
  );
}
